import React from "react";
import LegalPageLayout from "./LegalPageLayout";

export default function BuddyAvanzaTerms() {
  return (
    <LegalPageLayout
      documentKey="terms"
      testid="legal-terms"
      eyebrow="Documento legal"
      documentTitle="Términos y Condiciones de BUDDY AVANZA"
      intro="Estos Términos y Condiciones regulan el acceso y uso del servicio educativo digital BUDDY AVANZA. Al crear una cuenta, aceptar el consentimiento correspondiente o utilizar el servicio, aceptas las condiciones aquí descritas."
    >
      {({ contactEmail, operator }) => (<>
        <section>
          <h2>1. Identificación</h2>
          <p>
            BUDDY AVANZA es un servicio educativo digital desarrollado y operado por <strong>{operator}</strong>.
          </p>
        </section>

        <section>
          <h2>2. Naturaleza del servicio</h2>
          <p>
            BUDDY AVANZA proporciona herramientas de práctica, fortalecimiento
            de habilidades, seguimiento del progreso, controles de progreso,
            simulaciones, refuerzo y acompañamiento digital mediante Buddy.
            Su finalidad es educativa y de preparación.
          </p>
        </section>

        <section>
          <h2>3. Independencia</h2>
          <p>
            BUDDY AVANZA es una solución educativa <strong>independiente</strong>.
            No constituye plataforma oficial, aval, certificación, patrocinio ni
            afiliación del Ministerio de Educación, Ciencia y Tecnología de El
            Salvador (MINEDUCYT). Las referencias al nombre &quot;Prueba AVANZO&quot;
            se utilizan únicamente para identificar la evaluación con la que
            se relaciona la preparación ofrecida.
          </p>
        </section>

        <section>
          <h2>4. No garantía de resultados</h2>
          <p>
            BUDDY AVANZA no garantiza una calificación específica, un nivel de
            logro determinado, la aprobación ni un resultado concreto en la
            Prueba AVANZO. Los indicadores, controles de progreso y
            simulaciones internas reflejan el desempeño dentro de BUDDY AVANZA
            y no constituyen resultados oficiales de la Prueba AVANZO.
          </p>
        </section>

        <section>
          <h2>5. Condiciones comerciales</h2>
          <p>
            La oferta vigente al momento de esta versión de los términos es:
          </p>
          <ul>
            <li>Precio: <strong>US$19.99</strong>.</li>
            <li>Modalidad: pago único.</li>
            <li>Acceso: 60 días desde la activación de la cuenta.</li>
            <li>Sin renovación automática.</li>
          </ul>
          <p>
            Cualquier modificación futura del precio no alterará el período de
            acceso ya adquirido por una compra válida.
          </p>
        </section>

        <section>
          <h2>6. Registro</h2>
          <p>
            En BUDDY AVANZA, el correo electrónico funciona como nombre de
            usuario. Las credenciales son personales y no deben compartirse
            con terceros.
          </p>
        </section>

        <section>
          <h2>7. Estudiantes menores de 18 años</h2>
          <p>
            Cuando el estudiante sea menor de 18 años, el uso del servicio
            está sujeto al proceso de consentimiento parental establecido por
            BUDDY AVANZA. En estos casos se requieren correos electrónicos
            independientes para el estudiante y para el padre, madre, tutor
            legal o responsable autorizado.
          </p>
        </section>

        <section>
          <h2>8. Usuarios adultos</h2>
          <p>
            Las personas mayores de 18 años pueden aceptar directamente los
            documentos legales aplicables y utilizar el servicio bajo su
            propia responsabilidad.
          </p>
        </section>

        <section>
          <h2>9. Inteligencia artificial</h2>
          <p>
            Determinadas funcionalidades de BUDDY AVANZA pueden utilizar
            sistemas automatizados y tecnologías de inteligencia artificial
            para acompañar el razonamiento educativo del estudiante. Buddy
            busca apoyar el proceso de aprendizaje, no sustituir al estudiante
            ni al docente. Puedes conocer más en el <a href="/buddy-avanza/inteligencia-artificial">Aviso de Transparencia sobre IA</a>.
          </p>
        </section>

        <section>
          <h2>10. Limitaciones de la IA</h2>
          <p>
            Las respuestas generadas mediante inteligencia artificial pueden
            contener errores o imprecisiones. Buddy debe utilizarse como
            apoyo educativo y no como fuente infalible de información.
          </p>
        </section>

        <section>
          <h2>11. Disponibilidad</h2>
          <p>
            {operator} realizará esfuerzos razonables para mantener el
            servicio disponible. Pueden existir interrupciones por
            mantenimiento, actualizaciones, cambios de infraestructura,
            servicios de terceros u otras circunstancias razonables.
          </p>
        </section>

        <section>
          <h2>12. Licencia de uso</h2>
          <p>
            Se otorga un acceso personal, limitado y no transferible durante
            el período contratado. El acceso no incluye derechos de
            distribución, reventa, sublicencia ni redistribución.
          </p>
        </section>

        <section>
          <h2>13. Propiedad intelectual</h2>
          <p>
            BUDDY AVANZA, QHUB.BUDDY, {operator}, el software, diseño,
            arquitectura pedagógica y los contenidos propios se encuentran
            protegidos por la normativa aplicable. Se respetarán los
            derechos de terceros cuando corresponda.
          </p>
        </section>

        <section>
          <h2>14. Uso indebido</h2>
          <p>
            Podrá restringirse el acceso al servicio ante fraude, acceso no
            autorizado, scraping, extracción masiva de contenidos,
            manipulación, explotación de vulnerabilidades, compartición de
            credenciales, ataques o cualquier uso ilícito.
          </p>
        </section>

        <section>
          <h2>15. Actualizaciones</h2>
          <p>
            Los términos pueden actualizarse por cambios legales, operativos,
            tecnológicos o funcionales. Los cambios materiales podrán
            requerir una nueva aceptación.
          </p>
        </section>

        <section id="reembolsos">
          <h2>16. Reembolsos, retracto y reversión de pagos</h2>
          <p>
            BUDDY AVANZA es un servicio digital educativo de acceso temporal.
            Esta sección aplica a las solicitudes relacionadas con
            devoluciones, retracto, reversión de pagos o reintegros.
          </p>
          <p>
            <strong>Esta política no limita los derechos de retracto,
            reversión, reintegro u otros derechos que correspondan a la
            persona consumidora conforme a la legislación aplicable en El
            Salvador.</strong>
          </p>

          <h3>16.1 Cambio de opinión</h3>
          <p>
            Las solicitudes de devolución motivadas únicamente por cambio
            de opinión serán evaluadas conforme al estado de activación y
            uso del servicio y a los derechos que correspondan a la persona
            consumidora conforme a la legislación aplicable.
          </p>

          <h3>16.2 Servicio no prestado</h3>
          <p>
            Si el pago fue confirmado pero el acceso no fue entregado por
            causa atribuible a {operator}, la persona consumidora podrá
            comunicarse con {operator} para: (a) que se corrija el acceso
            y provisioning; o (b) que se procese el reintegro cuando
            legalmente corresponda.
          </p>

          <h3>16.3 Servicio diferente al contratado</h3>
          <p>
            Si el servicio entregado no corresponde materialmente a las
            condiciones de la oferta contratada, la persona consumidora
            podrá solicitar revisión a través del canal oficial de
            contacto. Se mantienen los derechos que correspondan conforme
            a la legislación aplicable.
          </p>

          <h3>16.4 Error o duplicidad de cobro</h3>
          <p>
            Se contemplan expresamente los casos de cobro duplicado, monto
            incorrecto, error de procesamiento y transacciones incorrectas
            atribuibles al sistema o al proveedor externo de procesamiento
            de pagos. Podrá solicitarse la revisión y el reintegro cuando
            corresponda.
          </p>

          <h3>16.5 Incidencia técnica</h3>
          <p>
            Se diferencian: (a) interrupciones breves o mantenimientos
            razonables, que no generan por sí solas devolución; y (b)
            imposibilidades materiales y persistentes atribuibles a{" "}
            {operator} que impidan sustancialmente utilizar el servicio,
            las cuales podrán ser revisadas y resueltas conforme a las
            condiciones aplicables y a los derechos del consumidor.
          </p>

          <h3>16.6 Cómo solicitar</h3>
          <p>
            Las solicitudes deben enviarse a{" "}
            <a href={`mailto:${contactEmail}`} data-testid="terms-refund-contact-email">{contactEmail}</a>{" "}
            indicando únicamente la información razonablemente necesaria
            para identificar la compra, la cuenta, la transacción y el
            motivo.
          </p>
          <p>
            <strong>{operator} nunca solicitará la contraseña de BUDDY
            AVANZA ni el CVV de la tarjeta para procesar una solicitud de
            este tipo.</strong> Tampoco se solicitará el número completo
            de tarjeta ni credenciales bancarias.
          </p>

          <h3>16.7 Titular del medio de pago</h3>
          <p>
            La transacción debe ser realizada por el titular del medio de
            pago o por una persona debidamente autorizada para utilizarlo.
          </p>
        </section>

        <section>
          <h2>17. Contacto</h2>
          <p>
            Para consultas relacionadas con BUDDY AVANZA puedes comunicarte
            con {operator} a través de{" "}
            <a href={`mailto:${contactEmail}`} data-testid="terms-contact-email">{contactEmail}</a>.
          </p>
        </section>
      </>)}
    </LegalPageLayout>
  );
}
